import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatSnackBar} from "@angular/material/snack-bar";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { RestApi } from '../RestApi/restApi';

interface extractionScheduleRecord {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class IncrDataLoadScheduleService {

  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi,
    private router: Router) { }

    insertExtractionSchedule(extractionScheduleData) {
      return this.http.post<extractionScheduleRecord>(this.restAPI.INSERT_EXTRACTION_SCHEDULE_URL, JSON.stringify(extractionScheduleData), { headers: this.headers });
    }
    async deleteDispatchHistory(id) {
      let response = await this.http.delete<extractionScheduleRecord>(this.restAPI.DELETE_EXTRACTION_SCHEDULE_URL + '/' + id, { headers: this.headers }).toPromise();

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      }
      else {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, "OK", { duration: 50000 });
      }
    }

    extractionScheduleList(scheduleFor) {
      return this.http.get<extractionScheduleRecord>(this.restAPI.EXTRACTION_SCHEDULE_LIST+ '/' + scheduleFor, {
        headers: this.headers
      });
    }
  extractionScheduleListByScheduleForAndReportTemplate(scheduleFor,templateId) {
    return this.http.get<extractionScheduleRecord>(this.restAPI.EXTRACTION_SCHEDULE_LIST+ '/' + scheduleFor +'/' + templateId, {
      headers: this.headers
    });
  }
}
